var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cog-picker cog-select cog-input",
      class: [
        {
          "is-read-only": _vm.readonly,
          "cog-select--has-image": _vm.hasImage(_vm.selectedValue),
          "cog-picker--allow-other": _vm.internalAllowOther,
          "cog-select--hidden-label":
            _vm.hideChoiceLabels && _vm.hasImage(_vm.selectedValue)
        },
        "cog-image-size--" + (_vm.readonly ? _vm.choiceImageSize + 1 : "1")
      ]
    },
    [
      _vm.readonly
        ? _c(
            "div",
            { staticClass: "cog-choice-option" },
            [
              _vm.selectedValue && _vm.hasImage(_vm.selectedValue)
                ? _c(
                    "CChoiceImage",
                    _vm._b(
                      { attrs: { option: _vm.selectedValue } },
                      "CChoiceImage",
                      {
                        isPersonField: _vm.isPersonField,
                        choiceImageSize: _vm.choiceImageSize,
                        fontSize: _vm.fontSize
                      },
                      false
                    )
                  )
                : _vm._e(),
              _vm.displayValue &&
              !(_vm.hideChoiceLabels && _vm.hasImage(_vm.selectedValue))
                ? _c("div", [
                    _vm._v(_vm._s(_vm._f("breakWords")(_vm.displayValue)))
                  ])
                : _vm._e()
            ],
            1
          )
        : [
            _vm.useNative
              ? _c(
                  "c-picker-native",
                  {
                    attrs: {
                      placeholder: _vm.placeholder,
                      "show-placeholder": !_vm.hidePlaceholder
                    },
                    scopedSlots: _vm._u(
                      [
                        _vm.showNativeChevron
                          ? {
                              key: "icon",
                              fn: function() {
                                return [_c("i-chevron")]
                              },
                              proxy: true
                            }
                          : null
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm.internalAllowOther
                      ? [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.internalValue,
                                expression: "internalValue"
                              }
                            ],
                            staticClass: "el-input__inner",
                            attrs: {
                              id: _vm.fullId,
                              type: "text",
                              list: _vm.id ? `cog-${_vm.id}-list` : null,
                              placeholder: _vm.placeholder,
                              "aria-required": _vm.isRequired
                                ? true
                                : undefined,
                              "aria-describedby": _vm.ariaDescriptions,
                              "aria-invalid": _vm.hasError ? true : undefined
                            },
                            domProps: { value: _vm.internalValue },
                            on: {
                              keydown: _vm.handleNativeMenuOpen,
                              click: _vm.handleNativeMenuOpen,
                              change: _vm.handleNativeChange,
                              focus: _vm.handleFocus,
                              blur: _vm.handleBlur,
                              input: function($event) {
                                if ($event.target.composing) return
                                _vm.internalValue = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "datalist",
                            {
                              attrs: {
                                id: _vm.id ? `cog-${_vm.id}-list` : null
                              }
                            },
                            [
                              _vm.showEmptyOption
                                ? _c("option", { domProps: { value: null } }, [
                                    _vm._v(" ")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.options, function(option) {
                                return _c(
                                  "option",
                                  {
                                    key: option.value,
                                    domProps: { value: option.value }
                                  },
                                  [_vm._v(_vm._s(option.displayValue))]
                                )
                              })
                            ],
                            2
                          )
                        ]
                      : _c(
                          "select",
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.internalValue,
                                  expression: "internalValue"
                                }
                              ],
                              ref: "nativeSelect",
                              staticClass: "el-input__inner",
                              class: { "is-null": !_vm.value },
                              attrs: {
                                id: _vm.fullId,
                                title: _vm.title,
                                "aria-required": _vm.isRequired
                                  ? true
                                  : undefined,
                                "aria-describedby": _vm.ariaDescriptions,
                                "aria-invalid": _vm.hasError ? true : undefined
                              },
                              on: {
                                keydown: _vm.handleNativeMenuOpen,
                                click: _vm.handleNativeMenuOpen,
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.internalValue = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  _vm.handleNativeChange
                                ],
                                focus: _vm.handleFocus,
                                blur: _vm.handleBlur
                              }
                            },
                            "select",
                            _vm.$attrs,
                            false
                          ),
                          [
                            _vm.showEmptyOption
                              ? _c("option", { domProps: { value: null } }, [
                                  _vm._v(" ")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.options, function(option) {
                              return _c(
                                "option",
                                {
                                  key: option.value,
                                  domProps: { value: option.value }
                                },
                                [_vm._v(_vm._s(option.displayValue))]
                              )
                            })
                          ],
                          2
                        )
                  ],
                  2
                )
              : _c(
                  "el-select",
                  _vm._b(
                    {
                      ref: "select",
                      attrs: {
                        id: _vm.fullId,
                        placeholder: _vm.placeholder,
                        "allow-create": _vm.internalAllowOther,
                        "no-data-text": " ",
                        "default-first-option": "",
                        filterable: _vm.filterable,
                        "filter-match": _vm.filterMatch,
                        "alternative-filter": _vm.alternativeFilter,
                        editable: _vm.internalAllowOther,
                        "automatic-dropdown": false,
                        "popper-class": _vm.popperClasses,
                        autocomplete: _vm.autocomplete,
                        title: _vm.title,
                        "aria-required": _vm.isRequired ? true : undefined,
                        "aria-describedby": _vm.ariaDescriptions,
                        "aria-invalid": _vm.hasError ? true : undefined,
                        "lazy-options": ""
                      },
                      on: {
                        focus: _vm.handleFocus,
                        blur: _vm.handleBlur,
                        change: _vm.handleChange,
                        "visible-change": _vm.handleSelectVisibleChange
                      },
                      nativeOn: {
                        change: function($event) {
                          return _vm.handleUserInputChange.apply(
                            null,
                            arguments
                          )
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          !_vm.prefixDefined &&
                          _vm.hasImageOption &&
                          !_vm.dropdownVisible &&
                          _vm.selectedValue &&
                          _vm.hasImage(_vm.selectedValue)
                            ? {
                                key: "prefix",
                                fn: function() {
                                  return [
                                    _c(
                                      "CChoiceImage",
                                      _vm._b(
                                        {
                                          staticClass:
                                            "cog-select__prefix-image",
                                          attrs: {
                                            option: _vm.selectedValue,
                                            "choice-image-size": 0
                                          }
                                        },
                                        "CChoiceImage",
                                        {
                                          isPersonField: _vm.isPersonField,
                                          fontSize: _vm.fontSize
                                        },
                                        false
                                      )
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            : null,
                          _vm.showSelectIcon
                            ? {
                                key: "suffix",
                                fn: function() {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        on: {
                                          click: _vm.handleIconClick,
                                          mousedown: _vm.handleIconMousedown
                                        }
                                      },
                                      [
                                        _vm._t("suffix", function() {
                                          return [_c("i-chevron")]
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            : null
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.internalValue,
                        callback: function($$v) {
                          _vm.internalValue = $$v
                        },
                        expression: "internalValue"
                      }
                    },
                    "el-select",
                    _vm.$attrs,
                    false
                  ),
                  [
                    _vm.showEmptyOption
                      ? _c(
                          "el-option",
                          {
                            staticClass: "cog-select-option--empty",
                            attrs: { value: null }
                          },
                          [_vm._v(" ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.options, function(option, index) {
                      return _c(
                        "el-option",
                        {
                          key: option.value + index,
                          style: { order: index },
                          attrs: {
                            value: option.value,
                            label: option.displayValue || _vm.nbsp
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cog-choice-option",
                              class: {
                                "cog-choice-option--no-image":
                                  _vm.hasImageOption &&
                                  !option.choiceThumbnailImage
                              }
                            },
                            [
                              _vm.hasImage(option)
                                ? _c(
                                    "CChoiceImage",
                                    _vm._b(
                                      {},
                                      "CChoiceImage",
                                      {
                                        option,
                                        isPersonField: _vm.isPersonField,
                                        choiceImageSize: _vm.choiceImageSize,
                                        fontSize: _vm.fontSize
                                      },
                                      false
                                    )
                                  )
                                : _vm.hasImageOption
                                ? _c("div", {
                                    staticClass: "cog-choice-image-container"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !(_vm.hideChoiceLabels && _vm.hasImage(option))
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        option.displayValue ||
                                          option.value ||
                                          _vm.nbsp
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }